import styled, { keyframes } from 'styled-components';
import { getSizeProps } from '../utils/spinnerHelpers';
import { getColor } from '../../Loading/utils/loadingHelpers'; // Reusing getColor helper

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const StyledSpinner = styled.i`
  display: inline-block;
  animation: ${rotate} 1s linear infinite;
  color: ${props => getColor(props.theme, props.color)};
  
  ${props => {
    const sizeProps = getSizeProps(props.size);
    return `font-size: ${sizeProps.fontSize};`;
  }}
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Spinner/components/SpinnerStyles.js